import { apolloQueryWrapper } from '@/shared/api';
import HOLTER_RR_CELLS_BEATS_QUERY from '@/entities/beat/api/queries/holterRrCellsBeats';
import type {
  ListHolterBeatsQuery,
  ListHolterBeatsQueryVariables,
} from '@/shared/api/generated/graphql';

export type HolterRrCellsBeats = {
  isSuccess: boolean;
  message: string;
  beats: any;
  hesBeatStatus: any;
  beatChannels: any;
  totalBeats: number;
  beatHeatMapIds: any;
  beatReviewed: any;
  beatTemplateIds: any;
};

// TODO(ts): typed as the ListHolterBeatsFilter GraphQL input once its server-side shape is documented
/**
 * Loads the beats backing the RR heat-map cells of a study. Runs the listHolterBeats query with limit merged into the filter and caching on, then returns the beat arrays with empty-array or zero defaults, throwing the server message when isSuccess is false.
 *
 * @param filter - GraphQL filter narrowing the beats to a study and cell selection.
 * @param limit - Maximum number of beats to request, merged into the filter.
 * @param key - Cancellation key identifying this request.
 * @param needCancel - Whether an in-flight request under the same key is cancelled first.
 * @returns A promise resolving to an object carrying beats, hesBeatStatus, beatChannels, totalBeats, beatHeatMapIds, beatReviewed and beatTemplateIds.
 */
const fetchHolterRrCellsBeats = async (
  filter: any,
  limit: number,
  key?: string | null,
  needCancel = true,
) => {
  const result = await apolloQueryWrapper<ListHolterBeatsQuery, ListHolterBeatsQueryVariables>({
    options: {
      query: HOLTER_RR_CELLS_BEATS_QUERY,
      variables: {
        filter: { ...filter, limit },
      },
    },
    isUsingCache: true,
    key,
    needCancel,
  });
  const { data } = result;
  const { listHolterBeats } = data;
  if (listHolterBeats?.isSuccess) {
    return {
      beats: listHolterBeats.beats ?? [],
      hesBeatStatus: listHolterBeats.hesBeatStatus ?? [],
      beatChannels: listHolterBeats.beatChannels ?? [],
      totalBeats: listHolterBeats.totalBeats ?? 0,
      beatHeatMapIds: listHolterBeats.beatHeatMapIds ?? [],
      beatReviewed: listHolterBeats.beatReviewed ?? [],
      beatTemplateIds: listHolterBeats.beatTemplateIds ?? [],
    };
  }
  throw new Error(listHolterBeats.message);
};

export default fetchHolterRrCellsBeats;
